import { SummarizeConversationResponse } from "requests/tanstack/useConversation";
import { create } from "zustand";

export type ConversationSummaryStore = {
  conversationsSummary: Record<string, SummarizeConversationResponse> | null;
  setConversationSummary: (
    summary: SummarizeConversationResponse,
    conversationdId: string
  ) => void;
  closeConversationSummary: (conversationdId: string) => void;
};

export const useConversationSummaryStore = create<ConversationSummaryStore>(
  (set, get): ConversationSummaryStore => ({
    conversationsSummary: null,
    setConversationSummary: (
      summary: SummarizeConversationResponse,
      conversationdId: string
    ) => {
      set({
        conversationsSummary: {
          ...get().conversationsSummary,
          [conversationdId]: summary,
        },
      });
    },
    closeConversationSummary: (conversationdId: string) => {
      const updatedSummary = { ...get().conversationsSummary };
      delete updatedSummary[conversationdId];
      set({ conversationsSummary: updatedSummary });
    }
  })
);
